import { QueryClient } from "@tanstack/react-query";

const CACHE_KEY = "pointo-query-cache";

// Fonction pour sauvegarder le cache dans localStorage
export const persistQueryClient = (queryClient: QueryClient) => {
  // Sauvegarder le cache toutes les 30 secondes
  const saveInterval = setInterval(() => {
    try {
      const cache = queryClient.getQueryCache();
      const queries = cache.getAll();

      const cacheData: Record<string, any> = {};
      queries.forEach((query) => {
        if (query.state.data) {
          // Utiliser la clé de requête comme identifiant
          const key = JSON.stringify(query.queryKey);
          cacheData[key] = {
            data: query.state.data,
            dataUpdatedAt: query.state.dataUpdatedAt,
          };
        }
      });

      localStorage.setItem(CACHE_KEY, JSON.stringify(cacheData));
    } catch (error) {
      console.error("[Cache] Erreur lors de la sauvegarde:", error);
    }
  }, 30000); // Toutes les 30 secondes

  // Sauvegarder aussi quand la page se ferme
  window.addEventListener("beforeunload", () => {
    clearInterval(saveInterval);
    try {
      const cache = queryClient.getQueryCache();
      const queries = cache.getAll();

      const cacheData: Record<string, any> = {};
      queries.forEach((query) => {
        if (query.state.data) {
          const key = JSON.stringify(query.queryKey);
          cacheData[key] = {
            data: query.state.data,
            dataUpdatedAt: query.state.dataUpdatedAt,
          };
        }
      });

      localStorage.setItem(CACHE_KEY, JSON.stringify(cacheData));
    } catch (error) {
      console.error("[Cache] Erreur lors de la sauvegarde finale:", error);
    }
  });
};

// Fonction pour restaurer le cache depuis localStorage
export const restoreQueryClient = (queryClient: QueryClient) => {
  try {
    const cachedData = localStorage.getItem(CACHE_KEY);
    if (cachedData) {
      const data = JSON.parse(cachedData);
      let restoredCount = 0;

      Object.entries(data).forEach(([key, value]: [string, any]) => {
        try {
          const queryKey = JSON.parse(key);
          queryClient.setQueryData(queryKey, value.data);
          restoredCount++;
        } catch (error) {
          console.warn(
            "[Cache] Erreur lors de la restauration d'une clé:",
            error
          );
        }
      });
    }
  } catch (error) {
    console.error("[Cache] Erreur lors de la restauration:", error);
  }
};
